import { FIELD_TYPE_OPTIONS } from "../constants/forms";
import { FieldType } from "../types/forms";

export const validatePhone = (value?: string, required?: boolean): boolean => {
  if (required && !value) return false;
  if (value) {
    const phone = value.replaceAll("-", "").trim();
    if (phone.length < 10) return false;
  }
  return true;
};

export const isValidSlug = (slug: string): boolean => {
  const slugPattern = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
  return slugPattern.test(slug);
};

export const getFieldTypeName = (fieldType: FieldType) => {
  return FIELD_TYPE_OPTIONS.find((opt) => opt.id === fieldType)?.label ?? "-";
};
